import { create } from "zustand";

interface PurchaseStepState {
  step: 1 | 2 | 3;
  setStep: (step: 1 | 2 | 3) => void;
}

const usePurchaseStepStore = create<PurchaseStepState>((set) => ({
  step: 1,
  setStep: (step) => set({ step }),
}));

export default usePurchaseStepStore;